(function (app) {
	var routes = app.routes = {};

	routes.common = {
		error: {
			name: 'error',
			config: {
				controller: 'ErrorController',
				controllerAs: '$ctrl'
			}
		},
		decline: {
			name: 'decline',
			config: {
				controller: 'DeclineController',
				controllerAs: '$ctrl'
			}
		},
		referral: {
			name: 'referral',
			config: {
				controller: 'DeclineController',
				controllerAs: '$ctrl'
			}
		},
		embargo: {
			name: 'embargo',
			config: {
				controller: 'DeclineController',
				controllerAs: '$ctrl'
			}
		},
		cybersourcePaymentForm: {
			name: 'cybersourcePaymentForm',
			config: {
				controller: 'CybersourcePaymentFormController',
				controllerAs: '$ctrl'
			}
		},
		cybersourceCallback: {
			name: 'cybersourceCallback',
			config: {
				controller: 'CybersourceCallbackController',
				controllerAs: '$ctrl'
			}
		},
		paypalCallback: {
			name: 'paypalCallback',
			config: {
				controller: 'PaypalCallbackController',
				controllerAs: '$ctrl'
			}
		},
		policyStartDate: {
			name: 'policyStartDate',
			config: {
				controller: 'PolicyStartDateController',
				controllerAs: '$ctrl'
			}
		}
	};

	routes.vehicle = {
		home: {
			name: 'vehicle',
			config: {
				abstract: true,
				template: '<div ui-view></div><div ui-view="sidebar"></div>'
			}
		},
		steps: [{
				name: 'vehicle.vehicle',
				config: {
					views: {
						'@': {
							controller: 'FormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'vehicle.drivers',
				config: {
					views: {
						'@': {
							controller: 'FormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'vehicle.quote',
				config: {
					views: {
						'@': {
							controller: 'FormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'vehicle.contact',
				config: {
					views: {
						'@': {
							controller: 'FormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'vehicle.payment',
				config: {
					views: {
						'@': {
							controller: 'PaymentController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'vehicle.done',
				config: {
					views: {
						'@': {
							controller: 'FormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'vehicle.policy-start-date',
				config: {
					views: {
						'@': {
							controller: 'PolicyStartDateController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {}
					}
				}
			}
		]
	};

	routes.ctp = {
		home: {
			name: 'ctp',
			config: {
				abstract: true,
				template: '<div ui-view></div><div ui-view="sidebar"></div>'
			}
		},
		steps: [{
			name: 'ctp.ctp',
			config: {
				views: {
					'@': {
						controller: 'ctpFormController',
						controllerAs: '$ctrl',
					},
					'sidebar@': {},
					'header@': {},
					'meta@': {},
					'progressbar@': {},
					'headbar@': {}
				}
			}
		}]
	};

	routes.bike = {
		home: {
			name: 'bike',
			config: {
				abstract: true,
				template: '<div ui-view></div><div ui-view="sidebar"></div>'
			}
		},
		steps: [{
				name: 'bike.bike',
				config: {
					views: {
						'@': {
							controller: 'BikeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'bike.riders',
				config: {
					views: {
						'@': {
							controller: 'BikeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'bike.quote',
				config: {
					views: {
						'@': {
							controller: 'BikeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'bike.contact',
				config: {
					views: {
						'@': {
							controller: 'BikeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'bike.payment',
				config: {
					views: {
						'@': {
							controller: 'PaymentController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'bike.done',
				config: {
					views: {
						'@': {
							controller: 'BikeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'bike.policy-start-date',
				config: {
					views: {
						'@': {
							controller: 'PolicyStartDateController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {}
					}
				}
			}
		]
	};

	routes.home = {
		home: {
			name: 'home',
			config: {
				abstract: true,
				template: '<div ui-view></div><div ui-view="sidebar"></div>'
			}
		},
		steps: [{
				name: 'home.estimate',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.property',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.building',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				},
				condition: function () {
					return true;
				}
			},
			{
				name: 'home.covers',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.details',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.quote',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.contact',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.payment',
				config: {
					views: {
						'@': {
							controller: 'PaymentController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.done',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.policy-start-date',
				config: {
					views: {
						'@': {
							controller: 'PolicyStartDateController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {}
					}
				}
			}
		]
	};


	routes.caravan = {
		home: {
			name: 'caravan',
			config: {
				abstract: true,
				template: '<div ui-view></div><div ui-view="sidebar"></div>'
			}
		},
		steps: [{
				name: 'caravan.caravan',
				config: {
					views: {
						'@': {
							controller: 'CaravanFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'caravan.drivers',
				config: {
					views: {
						'@': {
							controller: 'CaravanFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'caravan.quote',
				config: {
					views: {
						'@': {
							controller: 'CaravanFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'caravan.contact',
				config: {
					views: {
						'@': {
							controller: 'CaravanFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'caravan.payment',
				config: {
					views: {
						'@': {
							controller: 'PaymentController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'caravan.done',
				config: {
					views: {
						'@': {
							controller: 'CaravanFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'caravan.policy-start-date',
				config: {
					views: {
						'@': {
							controller: 'PolicyStartDateController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {}
					}
				}
			}
		]
	};

	routes.payments = {
		home: {
			name: 'payments',
			config: {
				abstract: true,
				template: '<div ui-view></div><div ui-view="sidebar"></div>'
			}
		},
		steps: [{
				name: 'payments.payments',
				config: {
					views: {
						'@': {
							controller: 'paymentsFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {}
					}
				}
			},
			{
				name: 'payments.complete',
				config: {
					views: {
						'@': {
							controller: 'paymentsFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {}
					}
				}
			}
		]
	};

})(window);
